// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../app/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".chart-container{font-size:12px;font-family:system-ui}.chart-container .dataTable.selectable tr{cursor:pointer}", ""]);
// Exports
module.exports = exports;
